<template>
  <div/>
</template>

<script>
export default {
  name: 'ConfigurationSettingsAB'
}
</script>